import { gql } from 'apollo-boost'

const SAVE_BRAND_DEFINITION_TASK = gql`
  mutation saveBrandDefinitionTask(
    $id: ID!
    $brandData: SaveBrandDefinitionTaskBrandInput
  ) {
    saveBrandDefinitionTask(id: $id, brandData: $brandData) {
      id
    }
  }
`

export default SAVE_BRAND_DEFINITION_TASK
